export function createEmptySelectionActionSelection() {
    return {
        line: 1,
        column: 1,
        hasSelection: false,
        selectedText: "",
    };
}

export function createSelectionActionMenuState({
    payload,
    enabled = true,
    menuWidth = 320,
    menuHeight = 44,
    margin = 8,
}) {
    if (!enabled) {
        return null;
    }

    const selection = payload?.selection;
    if (!selection?.hasSelection) {
        return null;
    }

    return {
        selection,
        position: {
            top: Math.max(margin, Math.min(window.innerHeight - menuHeight - margin, payload.top - menuHeight - 10)),
            left: Math.max(margin, Math.min(window.innerWidth - menuWidth - margin, payload.left - menuWidth / 2)),
        },
    };
}

export function createSelectionActionMenuItems({ onCopy, onCut, onAddReview, onAIEdit } = {}) {
    return [
        {
            id: "copy",
            label: "복사하기",
            icon: "copy",
            iconColor: "#486581",
            group: "clipboard",
            onSelect: onCopy,
        },
        {
            id: "cut",
            label: "잘라내기",
            icon: "copyCut",
            iconColor: "#486581",
            group: "clipboard",
            onSelect: onCut,
        },
        {
            id: "review-create",
            label: "리뷰 추가",
            icon: "thread",
            iconColor: "#0f8f6f",
            group: "review",
            onSelect: onAddReview,
        },
        {
            id: "ai-edit",
            label: "AI 편집",
            icon: "aiResponse",
            iconColor: "#2563eb",
            group: "ai",
            onSelect: onAIEdit,
        },
    ].filter((item) => typeof item.onSelect === "function");
}
